/**
 * Wildcard semantics (most-specific to least-specific):
 *   "<resource>:<action>"   — exact match
 *   "<resource>:*"          — all actions on a specific page
 *   "<app>.*:<action>"      — all pages in an app for a specific action
 *                             (e.g. "console.*:view" auto-tracks new
 *                             pageIds added to the console catalog)
 *   "<app>.*:*"             — full CRUD on every page in an app
 *   "*:<action>"            — global per-action (e.g. viewer = "*:view")
 *   "*"                     — root admin
 */
export function hasPermission(permissions, resource, action) {
    const dot = resource.indexOf(".");
    const appPrefix = dot > 0 ? resource.slice(0, dot) : null;
    for (const p of permissions) {
        if (p === "*")
            return true;
        if (p === `${resource}:${action}`)
            return true;
        if (p === `${resource}:*`)
            return true;
        if (p === `*:${action}`)
            return true;
        if (appPrefix) {
            if (p === `${appPrefix}.*:${action}`)
                return true;
            if (p === `${appPrefix}.*:*`)
                return true;
        }
    }
    return false;
}
export function canAny(permissions, resource) {
    const dot = resource.indexOf(".");
    const appPrefix = dot > 0 ? resource.slice(0, dot) : null;
    for (const p of permissions) {
        if (p === "*")
            return true;
        if (p === `${resource}:*`)
            return true;
        if (p.startsWith(`${resource}:`))
            return true;
        if (p.startsWith("*:"))
            return true;
        if (appPrefix && p.startsWith(`${appPrefix}.*:`))
            return true;
    }
    return false;
}
//# sourceMappingURL=check.js.map